




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class UnknownBlock extends Vue {
  @Prop({required: false})
  public readonly model: any;

  @Prop({required: true})
  public readonly type!: string;

  public mounted(): void {
    // tslint:disable-next-line
    console.warn('Encountered unknown CMS block of type', this.type, this.model);
  }
}
